import { useState } from "react";
import { List, XLg } from "react-bootstrap-icons";
import logo from "../../assets/full-argus-logo.png";
import NavbarLinks from "./NavbarLinks";
import "./styles/navbar.css";

const Navbar = () => {
  // stateful variables to handle the navbar
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [showModal, setShowModal] = useState(false);

  //Attach the event handler function to the window object
  window.addEventListener("resize", () => {
    setInnerWidth(window.innerWidth);
  });

  //An event handler function that shows the modal when the user clicks on the hamburger icon
  const handleShowModal = (e) => {
    setShowModal(!showModal);
  };

  return (
    // Navbar container
    <nav className="navbar-container" id="navbar-container">
      {/* Inner Navbar container */}
      <div className="navbar-inner">
        {/* Logo container */}
        <div id="logo-container">
          <a href="https://arguscs.com/vegas/" target="_blank" rel="noreferrer">
            {/* NOT LOADING PNG */}
            <img src={logo} alt="Argus Logo" className="logo" />
          </a>
          <h3 id="division-name">Nevada Division</h3>
        </div>
        {/* Navbar unordered list of links container */}
        <div
          className="nav-links-container"
          id={window.innerWidth < 1620 ? "hide-links" : ""}
        >
          {/* Display the links if the windows width is equal to or above 1300 */}
          {/* Unordered list */}
          {window.innerWidth >= 1620 ? (
            <ul id="nav-links-ul">
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Home
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/about/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  About
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/who-we-are/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Who We Are
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/services/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Services
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/markets/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Markets
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/who-we-serve/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Who We Serve
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/faq/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  FAQ
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/careers/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Careers
                </a>
              </li>
              <li className="nav-links-li">
                <a
                  href="https://arguscs.com/vegas/contact/"
                  className="nav-links-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact
                </a>
              </li>
              <li className="nav-links-li active-listItem">
                <a href="/" className="nav-links-link">
                  Client Portal
                </a>
              </li>
            </ul>
          ) : window.innerWidth < 1620 && showModal === true ? (
            <>
              <XLg
                id="x-btn"
                size={30}
                color={"white"}
                onClick={handleShowModal}
              />
              <NavbarLinks />
            </>
          ) : window.innerWidth < 1620 ? (
            // Display the hamburger icon if the windows width is below 1300
            <List
              id="hamburger"
              size={35}
              color={"white"}
              onClick={handleShowModal}
            />
          ) : null}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
